import React, { useContext, useEffect, useState } from "react";
import { useWindowSize } from "../../common/hooks/useWindowSize";
import { detectDeviceType } from "../../common/utils/common";
import { DeviceType } from "../../../utils/constants";

const MetaContext = React.createContext({
  deviceType: undefined,
  isMobile: false,
  isTab: false,
  isDesktop: false,
  isResponsive: false,
});

export const useMetaContext = () => useContext(MetaContext);

export const MetaContextProvider = ({ children }) => {
  const [screenWidth] = useWindowSize();
  const [deviceType, setDeviceType] = useState(detectDeviceType());

  useEffect(() => {
    const newDeviceType = detectDeviceType();
    if (newDeviceType !== deviceType) {
      setDeviceType(newDeviceType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenWidth]);

  const isMobile = deviceType === DeviceType.mobile;
  const isTab = deviceType === DeviceType.tablet;
  const isDesktop = deviceType === DeviceType.pc;
  const isResponsive = deviceType !== DeviceType.pc;

  return (
    <MetaContext.Provider
      value={{
        deviceType,
        isMobile,
        isTab,
        isDesktop,
        isResponsive,
      }}
    >
      {children}
    </MetaContext.Provider>
  );
};
